import React from 'react';
import { Bar } from 'react-chartjs-2';
import { tinycolor } from '@ctrl/tinycolor';
import _ from 'lodash';

export default class AccountManagerGPChart extends React.Component {
    render() {
        const labels = _.map(this.props.data, x => x.account_no + " - " + x.account_company);

        const colours = _.map(this.props.data, (x, i, l) => ({
            h: ((360.0 / l.length) * i), //random hue
            s: 0.9,
            l: 0.5,
            a: 1
        })
        );

        return (
            <Bar
                data={{
                    labels: labels,
                    datasets: [
                        {
                            label: 'Gross Profit',
                            data: _.map(this.props.data, x => x.total_gp),
                            backgroundColor: colours.map(x => tinycolor(x).toRgbString()),
                            hoverBackgroundColor: colours.map(x => tinycolor({ ...x, s: 0.8, l: 0.45 }).toRgbString()),
                        }
                    ]
                }}
            />
        );
    }
}